import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { motion } from "framer-motion";

export default function Catalogo() {
  const [imoveis, setImoveis] = useState<any[]>([]);

  useEffect(() => {
    const fetchImoveis = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "imoveis"));
        const imoveisArray = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setImoveis(imoveisArray);
      } catch (error) {
        console.error("Erro ao buscar imóveis:", error);
      }
    };
    fetchImoveis();
  }, []);

  return (
    <div className="pt-24 pb-16 px-8 bg-gray-100 min-h-screen">
      {/* Título estilizado */}
      <h2 className="text-4xl font-extrabold text-gray-800 text-center tracking-wide">
        📋 Catálogo de Imóveis
      </h2>

      {/* Linha decorativa */}
      <div className="w-24 h-1 bg-yellow-500 mx-auto my-4"></div>

      {/* Grid de imóveis */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
        {imoveis.length > 0 ? (
          imoveis.map((imovel) => (
            <motion.div
              key={imovel.id}
              className="bg-white shadow-md rounded-lg overflow-hidden transform hover:scale-105 transition duration-300 cursor-pointer hover:shadow-xl"
              whileHover={{ scale: 1.05 }}
            >
              {/* Imagem do imóvel */}
              <img
                src={imovel.imagem}
                alt={imovel.titulo}
                className="w-full h-56 object-cover rounded-t-lg"
              />

              {/* Conteúdo do card */}
              <div className="p-6">
                {/* Nome do imóvel */}
                <h3 className="text-2xl font-semibold text-gray-800">{imovel.titulo}</h3>

                {/* Localização */}
                <p className="text-gray-600 mt-1 flex items-center gap-2">
                  📍 {imovel.localizacao}
                </p>

                {/* Preço */}
                <p className="text-xl font-bold text-yellow-600 mt-2">
                  R$ {imovel.preco.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </p>

                {/* Características do imóvel */}
                <div className="flex items-center gap-4 mt-4 text-gray-700">
                  <span className="flex items-center gap-1">
                    🏠 {imovel.area}m²
                  </span>
                  <span className="flex items-center gap-1">
                    🛏️ {imovel.quartos} quartos
                  </span>
                  <span className="flex items-center gap-1">
                    🚗 {imovel.vagas} vagas
                  </span>
                </div>
              </div>
            </motion.div>
          ))
        ) : (
          <p className="text-center text-gray-600 text-lg col-span-3">
            Nenhum imóvel disponível no momento.
          </p>
        )}
      </div>
    </div>
  );
}
